export const WEB_TEMPLATE_BLUEPRINTS = [
    "torque",
    "nocturne",
] as const;

export type WebTemplateBlueprint = typeof WEB_TEMPLATE_BLUEPRINTS[number];

/**
 * Every public Web template deliberately inherits one of the two visual systems.
 * Keep this list explicit: choosing a blueprint is a design decision, not something
 * that should silently change when a catalog category is renamed.
 */
export const WEB_TEMPLATE_BLUEPRINT_BY_CODE = {
    "atelier-muse": "nocturne",
    "boutique-service": "nocturne",
    "craftsman-modern": "torque",
    "dental-studio": "torque",
    "groundwork-build": "torque",
    "kinetic-club": "nocturne",
    "launchpad-bold": "torque",
    "meridian-advisory": "torque",
    "nocturne-club": "nocturne",
    "northline-stay": "nocturne",
    "restaurant-brunch": "nocturne",
    "restaurant-cafe-brunch": "nocturne",
    "restaurant-modern": "nocturne",
    "restaurant-night-bar": "nocturne",
    "restaurant-pizzeria": "nocturne",
    "studio-clean": "torque",
    "takeres": "torque",
    "torque-service": "torque",
    "volt-flow": "torque",
} as const satisfies Record<string, WebTemplateBlueprint>;

export type WebTemplateBlueprintCode = keyof typeof WEB_TEMPLATE_BLUEPRINT_BY_CODE;

export const DEFAULT_WEB_TEMPLATE_BLUEPRINT: WebTemplateBlueprint = "torque";

export function isWebTemplateBlueprintCode(
    code: string | null | undefined,
): code is WebTemplateBlueprintCode {
    return Boolean(
        code
        && Object.prototype.hasOwnProperty.call(
            WEB_TEMPLATE_BLUEPRINT_BY_CODE,
            code,
        ),
    );
}

export function resolveWebTemplateBlueprint(
    code: string | null | undefined,
): WebTemplateBlueprint {
    return isWebTemplateBlueprintCode(code)
        ? WEB_TEMPLATE_BLUEPRINT_BY_CODE[code]
        : DEFAULT_WEB_TEMPLATE_BLUEPRINT;
}

export function webTemplateCodesForBlueprint(
    blueprint: WebTemplateBlueprint,
): WebTemplateBlueprintCode[] {
    return (Object.entries(WEB_TEMPLATE_BLUEPRINT_BY_CODE) as Array<[
        WebTemplateBlueprintCode,
        WebTemplateBlueprint,
    ]>)
        .filter(([, candidate]) => candidate === blueprint)
        .map(([code]) => code);
}
